import { useEffect } from "react";
import ReactDOM from "react-dom";
import { useSignal } from "@preact/signals";
export default function Portal(props) {
    const { container } = props;
    const renderContainer = useSignal(container ? container() : null);
    useEffect(() => {
        if (!container) {
            const node = document.createElement("div");
            document.body.appendChild(node);
            renderContainer.value = node;
            return () => {
                document.body.removeChild(node);
            };
        }
    }, [container, renderContainer]);
    if (!renderContainer.value) {
        return null;
    }
    return ReactDOM.createPortal(props.children, renderContainer.value);
}
